import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarEvent } from '../events';

@Component({
    selector: 'app-edit-event',
    templateUrl: './edit-event.component.html',
    styleUrls: ['./edit-event.component.scss'],
})
export class EditEventDialogComponent implements OnInit {
    title = 'Calendar Event Editor';
    event: CalendarEvent;
    listofevents: string[];
    eventEditorForm: FormGroup;

    // Getters for form validation error messages
    get EventName(): AbstractControl {
        return this.eventEditorForm.controls.EventName;
    }

    constructor(
        private dialogRef: MatDialogRef<EditEventDialogComponent>,
        private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.event = data.event;
        this.listofevents = data.eventNames;
        this.title = this.data.title;
    }

    ngOnInit(): void {
        this.eventEditorForm = this.formBuilder.group({
            EventName: [this.event.eventName, [Validators.required, isEventNameTaken(this.event.eventName, this.listofevents)]],
            EventDesc: [this.event.eventDesc],
            EventUrl: [this.event.eventUrl],
            EventNotes: [this.event.eventNotes],
            EventContact: [this.event.eventContact],
            CatCommunity: [this.event.catCommunity],
            //   CatDepartmentIt: [this.event.catDepartmentIt],
            CatParents: [this.event.catParents],
            CatSchools: [this.event.catSchools],
            CatStaff: [this.event.catStaff],
            CatStudents: [this.event.catStudents],
        });
    }

    onNoClick(): void {
        this.dialogRef.close(null);
    }

    onSubmit(formValues): void {
        this.eventEditorForm.markAllAsTouched();

        if (this.eventEditorForm.valid) {
            this.event.eventName = formValues.EventName;
            this.event.eventDesc = formValues.EventDesc;
            this.event.eventUrl = formValues.EventUrl;
            this.event.eventNotes = formValues.EventNotes;
            this.event.eventContact = formValues.EventContact;
            this.event.catCommunity = formValues.CatCommunity;
            //   this.event.catDepartmentIt = formValues.CatDepartmentIt;
            this.event.catParents = formValues.CatParents;
            this.event.catSchools = formValues.CatSchools;
            this.event.catStaff = formValues.CatStaff;
            this.event.catStudents = formValues.CatStudents;

            this.dialogRef.close(this.event);
            this.eventEditorForm.reset();
        }
    }
}

/* Validation function to see if the inputted EventName already exists. If so, the field will become invalid.
 * This error will NOT occurr if, while editing an existing EventName, the user reverts changes to match the
 * original name provide to the form prior to saving.
 */
function isEventNameTaken(name: string, listOfEvents: string[]): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
        const isNameTaken = listOfEvents.some((value) => value === control.value);
        const error = isNameTaken && control.dirty && control.value !== name ? { isNameTaken: true } : null;
        return error;
    };
}
